module.exports = __webpack_public_path__ + "static/media/graph-database-intro-img-1.070fca14.png";